/**
 * Defilement anime de la page, ecrit a la main.
 *
 * Source unique du geste « descendre jusqu'a » du theme : le CTA du hero
 * (<go-config-anchor>) comme les raccourcis du nuancier et des Nouveautes
 * (<go-configurator-link>) passent par ici. Deux implementations divergentes du
 * meme mouvement finiraient par ne plus se ressembler.
 *
 * Pourquoi ne pas utiliser `scrollIntoView({ behavior: 'smooth' })` : Chrome
 * ANNULE le defilement anime des que le systeme demande de reduire les
 * animations. Sur un poste Windows ou l'option est active — le cas du poste de
 * travail de ce projet — la page sautait d'un bloc jusqu'a la cible.
 *
 * Le mouvement n'est pas une decoration ici : c'est lui qui dit que la cible est
 * sur la MEME page, quelques sections plus bas ou plus haut. Un saut sec se lit
 * comme un changement de page, et on perd le fil de ce qu'on regardait. D'ou ce
 * choix explicite de passer outre la preference systeme, comme `go-marquee` le
 * fait deja pour son bandeau — et, comme lui, il reste borne : le mouvement dure
 * moins d'une seconde et s'arrete des que le visiteur touche a quoi que ce soit.
 *
 * Usage :
 *   window.goSmoothScrollTo(element.getBoundingClientRect().top + window.scrollY);
 */
(function () {
  // Le defilement anime porte sur la fenetre : il n'y en a qu'un a la fois, d'ou
  // cet etat au niveau du module plutot que par appelant.
  let frame = null;
  let abort = null;

  // On n'ecoute pas `scroll`, que notre propre animation emet a chaque image.
  const INTERRUPTIONS = ['wheel', 'touchstart', 'keydown'];

  function stop() {
    cancelAnimationFrame(frame);
    if (!abort) return;
    INTERRUPTIONS.forEach((type) => window.removeEventListener(type, abort));
    abort = null;
  }

  function travel(destination) {
    const start = window.scrollY;
    const limit = document.documentElement.scrollHeight - window.innerHeight;
    const distance = Math.max(0, Math.min(destination, limit)) - start;

    // Deja a destination : rien a animer, et surtout rien a bloquer.
    if (Math.abs(distance) < 1) return;

    stop();

    // Duree proportionnelle a la distance, bornee aux deux bouts : un court
    // deplacement ne doit pas trainer, une longue page ne doit pas devenir
    // interminable.
    const duration = Math.min(900, Math.max(400, Math.abs(distance) * 0.6));
    const started = performance.now();

    // Le visiteur reprend la main a tout moment : molette, doigt ou touche
    // arretent net l'animation, sinon les deux se disputent le defilement.
    abort = stop;
    INTERRUPTIONS.forEach((type) => window.addEventListener(type, abort, { passive: true }));

    function step(now) {
      const progress = Math.min(1, (now - started) / duration);
      // easeInOutCubic : depart et arrivee amortis, le mouvement se lit comme un
      // deplacement continu plutot que comme un rattrapage.
      const eased =
        progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      window.scrollTo(0, start + distance * eased);

      if (progress < 1) {
        frame = requestAnimationFrame(step);
      } else {
        stop();
      }
    }

    frame = requestAnimationFrame(step);
  }

  // Meme garde que les composants GO! : plusieurs sections emettent la balise
  // <script src>, qui s'execute alors une fois par balise.
  if (!window.goSmoothScrollTo) {
    window.goSmoothScrollTo = travel;
  }
})();
